import { Button, Popconfirm, Space, Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import moment from 'moment'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import routes from '@/constants/routes'
import { Customer } from '@/types'

import { CustomRowTable } from './styles'

type Props = {
  dataSource: Customer[] | undefined
  getOperatorsLoading: boolean
  onDelete: (id: Customer['id']) => void
}

const OperatorsTable = ({ dataSource, getOperatorsLoading, onDelete }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [visibleConfirmDelete, setVisibleConfirmDelete] = useState<Record<string, boolean>>({})

  const columns: ColumnsType<Customer> = [
    {
      title: t('components.pages.operators.list.table.id'),
      dataIndex: 'id',
      key: 'id',
      render: (record: Customer) => {
        return <CustomRowTable type="right">{record}</CustomRowTable>
      },
      align: 'center' as const,
    },
    {
      title: t('components.pages.operators.list.table.companyId'),
      dataIndex: 'code',
      key: 'code',
      render: (record: Customer) => {
        return <CustomRowTable type="right">{record}</CustomRowTable>
      },
      align: 'center' as const,
    },
    {
      title: t('components.pages.operators.list.table.companyName'),
      dataIndex: 'name',
      key: 'name',
      render: (record: Customer) => {
        return <CustomRowTable type="left">{record}</CustomRowTable>
      },
      align: 'center' as const,
    },
    {
      title: t('components.pages.operators.list.table.createdAt'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (record: Customer) => {
        return <CustomRowTable type="left">{moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss')}</CustomRowTable>
      },
      align: 'center' as const,
    },
  ]

  columns.push({
    align: 'center' as const,
    render: (text: string, record: Customer) => {
      return (
        <Space size="middle">
          <Button size="small" onClick={() => goToEditOperatorPage(record.id)}>
            {t('components.pages.admins.list.table.update')}
          </Button>
          <Popconfirm
            id={record.id.toString()}
            visible={!!visibleConfirmDelete[record.id]}
            title={t('components.pages.attendanceLogs.list.table.confirmDelete')}
            okText={t('common.yes')}
            cancelText={t('common.no')}
            onConfirm={() => {
              onDelete(record.id)
            }}
            onCancel={() => setVisibleConfirmDelete({})}
          >
            <Button size="small" danger onClick={() => setVisibleConfirmDelete({ [record.id]: true })} loading={false}>
              {t('components.pages.admins.list.table.delete')}
            </Button>
          </Popconfirm>
        </Space>
      )
    },
  })

  const goToEditOperatorPage = (id: Customer['id']) => {
    navigate(`${routes.operators.path}/${id}`)
  }

  return <Table rowKey="id" bordered dataSource={dataSource} columns={columns} loading={getOperatorsLoading} />
}

OperatorsTable.displayName = 'OperatorsTable'
export default OperatorsTable
